import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import FullCalendar from '@fullcalendar/react';
import { format } from 'date-fns';

const CalendarWidget = ({ events = [] }) => {
  const calendarEvents = events.map(event => ({
    title: event.title,
    date: format(new Date(event.date), 'yyyy-MM-dd'),
    extendedProps: {
      location: event.location,
      eventType: event.eventType
    }
  }));

  const eventContent = (eventInfo) => {
    return (
      <div className="fc-event-content">
        <div className="font-medium">{eventInfo.event.title}</div>
        {eventInfo.event.extendedProps.location && (
          <div className="text-xs truncate">{eventInfo.event.extendedProps.location}</div>
        )}
      </div>
    );
  };

  return (
    <div className="bg-white p-4 rounded-xl shadow-sm">
      <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        events={calendarEvents}
        headerToolbar={{
          left: 'title',
          center: '',
          right: 'prev,next today'
        }}
        height={500}
        eventContent={eventContent}
        eventClassNames="cursor-pointer hover:opacity-90"
      />
    </div>
  );
};

export default CalendarWidget;